const isOptionalString = (value) => value == null || typeof value === "string";

export const createAuditLogInput = ({
  activity,
  details = "",
  user,
  voyageId = null,
  tripId = null,
  cargoId = null,
} = {}) => {
  if (typeof activity !== "string" || !activity.trim()) {
    throw new Error("audit log activity must be a non-empty string");
  }

  if (typeof details !== "string") {
    throw new Error("audit log details must be a string");
  }

  if (!isOptionalString(user)) {
    throw new Error("audit log user must be a string when provided");
  }

  if (![voyageId, tripId, cargoId].every(isOptionalString)) {
    throw new Error("audit log scope IDs must be strings when provided");
  }

  return {
    activity: activity.trim(),
    details,
    user: user?.trim() || null,
    voyageId,
    tripId,
    cargoId,
  };
};
